// Template
require('./dashforge/dashforge');
const select2 = require('select2');
const flatpickr = require("flatpickr");

$(document).ready(function () {
    $(".select2").select2();
    flatpickr(".flatpickr", {
        defaultDate: 'today'
    });
    $('[data-toggle="tooltip"]').tooltip();

    $("#addOrderLine").click(function (e) {
        e.preventDefault();
        addOrderLine();
    });
});

function addOrderLine() {
    let line = $(".order-line").html();
    $(".order-lines").append(line);
}
